import {
  types,
  getRoot,
  // isAlive
} from 'mobx-state-tree';

export const SellerAccountsSelection = types
  .model({
    allAccountsSelected: false,
  })
  .views(self => ({
    // get allSelectedSellerAccountsAlive() {
    //   return self.selectedSellerAccounts.every(acc=>isAlive(acc));
    // },
    get selectedAccountsObj() {
      // if(this.allSelectedSellerAccountsAlive){
      return Object.fromEntries(
        self.selectedSellerAccounts.filter(o => !!o).map(o => [o.id, { ...o }]),
      );
      // }
      // return {};
    },
    get sellerAccounts() {
      return getRoot(self).uiStore.settingsStore.markets.sellersAccounts;
    },
    get accountsQueryString() {
      const str = '&sellerAccountId=';
      return self.selectedSellerAccounts
        .filter(o => !!o)
        .map(({ id }) => id)
        .join(str);
    },
    get accountsQueryStringDashboard() {
      return self.selectedSellerAccounts
        .filter(o => !!o)
        .map(({ id }) => id)
        .join(',');
    },
  }))
  .actions(self => ({
    selectAccount(account) {
      const exist = self.selectedAccountsObj[account.id] !== undefined;
      if (exist) {
        self.removeAccount(account);
      } else {
        self.setSelectedSellerAccount(account);
      }
    },
    removeAccount(account) {
      self.selectedSellerAccounts = [...self.selectedSellerAccounts].filter(
        ({ id }) => id !== account.id,
      );
    },
    setSelectedSellerAccount(account, setDefaultAccount = false) {
      if (setDefaultAccount) {
        self.selectedSellerAccounts = [self.defaultSellerAccount];
      } else {
        self.selectedSellerAccounts = [...self.selectedSellerAccounts, account];
      }
    },
    toggleSellectAllAccounts(listLength) {
      if (self.selectedSellerAccounts.length === listLength) {
        self.selectedSellerAccounts = [];
      } else {
        self.selectedSellerAccounts = [...self.sellerAccounts];
      }
    },
    toggleSellectHeaderAccounts() {
      self.selectedSellerAccounts = self.sellerAccounts.length > 15 ? [...self.sellerAccounts.slice(0,0)] : [...self.sellerAccounts.slice(0,5)];
    },
  }));

export default SellerAccountsSelection;
